import { render, staticRenderFns } from "./CanceledContracts.vue?vue&type=template&id=0883d011&scoped=true&"
import script from "./CanceledContracts.vue?vue&type=script&lang=js&"
export * from "./CanceledContracts.vue?vue&type=script&lang=js&"
import style0 from "./CanceledContracts.vue?vue&type=style&index=0&id=0883d011&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0883d011",
  null
  
)

export default component.exports